import '../constants/authorizedUsers.js';
import '../constants/bidStatus.js';
import '../constants/bulkLoadCardStatus.js';
import '../constants/misc.js';
import '../constants/event-names.js';
import '../constants/eventsMapObj.js';
import '../constants/Faq.js';
import '../constants/languages.js';
import '../constants/loadStatus.js';
import '../constants/lorryStatus.js';
import '../constants/lorryTypes.js';
import '../constants/mostSearchedLinks.js';
import '../constants/Pages.js';
import 'bowser';
import '../_virtual/_tslib.js';
import '../components/toast/toast.js';
import '../_services/auth.service.js';
import './getAuthIdParam.js';
import 'react';
import 'react-cookie';
import './formatDate.js';
import '../constants/StateList.js';
import './getTransporterFigure.js';
import './getDownloadsFigure.js';
import 'lodash.isequal';
import './getPageLoadSourceUTMParam.js';
import 'crypto-js';
import '../constants/serviceTypeId.js';
import '../constants/bidUpdateType.js';
import '../constants/userAction.js';
import '../constants/api.js';
import '../constants/link.js';
import '../constants/market.js';
import '../constants/payment.js';
import { companyNameCharLimit } from '../constants/regex.js';
import '../constants/admin/screenId.js';
import '../_services/const.js';

function isValidCompanyName(companyName) {
    /* if company name is undefined or empty or length is greater than companyNameCharLimit it is not valid
     * if three consecutive numbers are there then it is not valid
     * if the character is not alphanumeric or space, return false
     * total number of digits in the name cannot exceed 6 */
    var _a;
    if (!companyName ||
        companyName.length <= 0 ||
        companyName.length > companyNameCharLimit ||
        companyName.match(/[0-9]{3,}/g) ||
        companyName.match(/[^a-z0-9 ]/gi) ||
        ((_a = companyName.match(/[0-9]/g)) === null || _a === void 0 ? void 0 : _a.length) > 6) {
        return false;
    }
    return true;
}

export { isValidCompanyName };
//# sourceMappingURL=isValidCompanyName.js.map
